import {TooltipTextAlign} from 'common/components/tooltip/types';

// @ts-strict-ignore
export interface TooltipTourState {
  isDismissed: boolean;
  isVisible: boolean;
}

export type TooltipTourParams = {
  uniqueTourName: TourName;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  title: string;
  markdownText: string;
  showDoNotShowCheckbox?: boolean;
  imageSrc?: string;
  textAlign?: TooltipTextAlign;
  // event handlers
  onPrimaryButtonClick?: (ev?) => void;
  onSecondaryButtonClick?: (ev?) => void;
  onCheckboxClick?: () => void;
};

export interface TooltipTourJsxProps {
  params?: TooltipTourParams;
}

export type PersistedDismissTooltipTour = {
  tips: string[];
};

export enum TourName {
  QueryTimeSampling = `query_time_sampling`,
  SubscribeToBoard = `subscribe_to_board`,
}

export const DISMISS_KEY = `dismissTourTips`;
